import { render, staticRenderFns } from "./ClientRegiment.vue?vue&type=template&id=1e12270f&"
import script from "./ClientRegiment.vue?vue&type=script&lang=js&"
export * from "./ClientRegiment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports